import { useIntl } from "react-intl";

export const PromotionItem = ({ promo, onClick, className }) => {
  const intl = useIntl();
  if (!promo) return null;

  return (
    <div
      className={`rounded p-3 border ${className}`}
      style={onClick ? { cursor: "pointer" } : undefined}
      onClick={onClick}
    >
      <div className="fw-bold pb-2 mb-2 border-bottom">
        {promo.promotiontitle}
      </div>
      <div className="d-flex">
        <div className="pe-2">{intl.formatMessage({ id: "free" })} : </div>
        <div className="pe-1">{promo.free}</div>
        <div>({promo.givetype})</div>
      </div>
      <div className="d-flex">
        <div className="pe-2">{intl.formatMessage({ id: "turnover" })} : </div>
        <div>{promo.turnover}</div>
      </div>
      <div className="d-flex">
        <div className="pe-2">{intl.formatMessage({ id: "minMax" })} : </div>
        <div>
          {promo.topupmin} ~ {promo.topupmax}
        </div>
      </div>
      <div className="d-flex">
        <div className="pe-2">{intl.formatMessage({ id: "type" })} :</div>
        <div>
          {promo.promotionGameTypeListsV2
            ?.map((promoGameType) => promoGameType.gametype)
            .join(",")}
        </div>
      </div>
    </div>
  );
};
